import {environment} from '../../../../../environments/environment';
interface AuthConfig {
  clientID: string;
  domain: string;
  callbackURL: string;
  apiUrl: string;
  audience: string;
}

export const AUTH_CONFIG: AuthConfig = {
  clientID: environment.auth0ClientID,
  domain: environment.auth0Domain,
  callbackURL: environment.callbackURL,
  apiUrl: environment.apiUrl,
  audience: environment.auth0Audience
};



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/user/services/auth/auth0-variables.ts